import { render, staticRenderFns } from "./TimePartsSingleEditor.vue?vue&type=template&id=6587c20c&"
import script from "./TimePartsSingleEditor.vue?vue&type=script&lang=js&"
export * from "./TimePartsSingleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports